import { Component, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import {
  BenefitWithoutCoupon,
  BfluenceIntegrityControllerService
} from 'src/app/admin-api';
import { TableColumn, TableComponent } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-benefit-without-coupon',
  templateUrl: './benefit-without-coupon.component.html',
  styleUrl: './benefit-without-coupon.component.scss',
  providers: [ConfirmationService, MessageService]
})
export class BenefitWithoutCouponComponent {
  @ViewChild(TableComponent) table: TableComponent;

  columns: Array<TableColumn> = [
    new TableColumn('', '', false, 'checkbox'),
    new TableColumn(
      'SubscriberId',
      'subscriberId',
      true,
      'number',
      '/users/subscribers/',
      'subscriberId'
    ),
    new TableColumn(
      'PersonId',
      'personId',
      true,
      'number',
      '/users/person/',
      'personId'
    ),
    new TableColumn('FirstName', 'firstName', true, 'text'),
    new TableColumn('Email', 'email', true, 'text'),
    new TableColumn('EditionId', 'editionId', true, 'number'),
    new TableColumn('SubscriptionId', 'subscriptionId', true, 'number'),
    new TableColumn('PaymentId', 'paymentId', true, 'number'),
    new TableColumn('PaymentLogId', 'paymentLogId', true, 'number'),
    new TableColumn('InsertCoupon', 'insertCoupon', true, 'text')
  ];

  constructor(
    public bfluenceIntegrityService: BfluenceIntegrityControllerService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  markAsResolved(elements: Array<BenefitWithoutCoupon>): void {
    this.confirmationService.confirm({
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      rejectButtonStyleClass: 'p-button-danger',
      message: 'Deseja ajustar estes benefícios?',
      header: 'Ajustar Benefícios',
      accept: async () => {
        LoaderService.showLoader();
        try {
          await lastValueFrom(
            this.bfluenceIntegrityService.fixBenefitWithoutCoupon(elements)
          );
          await this.table.refresh(true);
          this.messageService.add({
            summary: 'Sucesso',
            detail: elements.length + ' marcado(s) como resolvido(s)',
            severity: 'success'
          });
          LoaderService.showLoader(false);
        } catch (error) {
          LoaderService.showLoader(false);
          AppDialogService.showErrorDialog(error);
        }
      }
    });
  }
}
